import {
  getPatientFlowOverview,
  type PatientFlowOverviewResult,
} from '@services/api/dashboard/scheduling.api'
import { useAppSelector } from '@store/hooks'
import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'

/** Patient Flow Tracker is always day-scoped (ignores Overview 1D–YTD range). */
export function usePatientFlowOverview(
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<PatientFlowOverviewResult> {
  const refreshKey = useAppSelector((state) => state.patient.refresh)
  const queryParams = useDashboardPeriodParams('1D', date)
  return useDashboardPeriodFetch(queryParams, getPatientFlowOverview, {
    refreshKey,
    enabled,
    queued,
  })
}
